export default "__VITE_ASSET__779286d7__"